import { Color } from '@/components/portfolio/components/sharedTypes'
import { CFImage, clientHomeData, clientPageData, PortfolioComponent } from '../../type/client-index'
import {
  IGProfile,
  Poster,
  Shoot1,
  Shoot2,
  Shoot3,
  Shoot4,
  Shoot5,
  Shoot6,
  Story1,
  Story2,
  Story3,
  Story4,
  Story5,
  Tag
} from './images'

export const home: clientHomeData = {
  slug: 'signe-nature',
  name: 'Signe Nature',
  types: ['Identité visuelle', 'Shooting direction artistique'],
  image: IGProfile
}

const detailed: clientPageData = {
  seo: {
    title: 'Signe Nature',
    description: 'Découvrez notre travail avec Signe Nature.'
  },
  blocks: [
    {
      id: 1,
      componentName: PortfolioComponent.presentationSlide,
      props: {
        title: home.name,
        types: home.types,
        titleColor: Color.yellow,
        images: [IGProfile],
        urls: {
          website: 'https://www.signenature.be/',
          instagram: 'https://www.instagram.com/signe.nature/'
        },
        subtitle: 'La marque',
        description: {
          cols: 2,
          content: [
            "Signe Nature, c'est une marque belge de prêt-à-porter féminin. Avec ses pièces colorées et ses coupes classiques, elle séduit des femmes de tous âges et les accompagne dans différentes occasions.",
            "Que ce soit la robe droite bleu marine à l'ensemble à motifs, les pièces Signe Nature offrent élégance et assurance, le tout en couleurs ! N'hésitez pas à découvrir ce que le dressing de la marque propose."
          ]
        }
      }
    },
    {
      id: 2,
      componentName: PortfolioComponent.horizontalImagesShowcase,
      props: {
        title: 'Notre travail',
        description: {
          cols: 2,
          content: [
            "Pour coller à leur nouveau positionnement, Atelier Milky a développé un tout nouveau logo accompagné d'une charte graphique correspondante.",
            'Nouvelles couleurs, nouveaux supports de communication mais aussi nouvelle identité pour les réseaux sociaux, nous nous sommes chargés de refaire une beauté à la marque belge !'
          ]
        },
        shadow: true,
        respectImageDimension: true,
        images: [Story1, Story2, Story3, Story4, Story5]
      }
    },
    {
      id: 3,
      componentName: PortfolioComponent.imageTopDescriptionBottom,
      props: {
        image: Tag,
        width: 20,
        description:
          "Mais le travail ne s'est pas arrêté là ! Afin d'annoncer ce nouveau départ, une stratégie digitale ainsi qu'une stratégie influence ont été développées. Conseils stratégiques, idées de publication mais aussi astuces secrètes, Atelier Milky a tout prévu pour une entrée fracassante."
      }
    },
    {
      id: 4,
      componentName: PortfolioComponent.imageTopDescriptionBottom,
      props: {
        image: Poster,
        width: 37.5,
        description:
          'Pour accompagner cette nouvelle identité, nous avons également réalisé un shooting avec direction artistique dont le thème principal était la silhouette féminine. Formes arrondies, ombres, aplats de couleurs, le concept a été travaillé et développé pour un effet maximum!'
      }
    },
    {
      id: 5,
      componentName: PortfolioComponent.imageGrid,
      props: {
        images: [Shoot1, Shoot2, Shoot3, Shoot4, Shoot5, Shoot6],
        variant: 2,
        rightPadding: true
      }
    }
  ]
}

export default detailed
